if( !customElements.get("cian-content-mobile-gallery") ) customElements.define("cian-content-mobile-gallery", class extends HTMLElement {
    static get observedAttributes() {
        return ['flat-id', 'jk-ref'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (
          (name === 'flat-id' || name ==='jk-ref')
          && oldValue !== newValue
        ) {
            this.connectedCallback()
        }
    }
    async getPhotos() {
        let cacheUrl = false;
        let renderUrl = false;
        if (this.hasAttribute('flat-id')) {
            const id = this.getAttribute('flat-id');
            cacheUrl = `https://cdn.cian.site/finance/content-distribution/flat-photo/${id}.json`;
            renderUrl = `https://content-distribution-photogallery-service.content.cian.ru/api/v1/flat/${id}`;
        }
        if (this.hasAttribute('jk-ref')) {
            const jkRef = this.getAttribute('jk-ref');
            const id = /-([0-9]+)[^0-9]*$/.exec(jkRef)[1];
            cacheUrl = `https://cdn.cian.site/finance/content-distribution/jk/${id}.json`;
            renderUrl = `https://content-distribution-photogallery-service.content.cian.ru/api/v1/jk/&?jk_name=${encodeURIComponent(jkRef)}`;
        }

        function getNotCachedContent() {
            return fetch(renderUrl).then((result) => {
                if (result.ok) {
                    return result.json();
                }
                return [];
            });
        }
        try{
            let response = await fetch(cacheUrl);

            if (response.status === 404) {
                response = await fetch(renderUrl);
                return await response.json();
            }

            if (!response.ok) {
                throw new Error('Failed to request')
            }
            return await response.json().then(photos => {
                let last = customElements.get('last-photo-promo');
                if(last) {
                    photos.push({
                        customElementName: 'last-photo-promo', thumbnailUrl: last.thumbnailUrl
                    });
                }
                return photos;
            });
        }  catch (e) {
            let response = await fetch(renderUrl);
            return await response.json();

        }
    }

    async connectedCallback() {
        window.addEventListener('touchstart', this.touchStart);
        window.addEventListener('touchmove', this.preventTouch, {passive: false});

        this.fullScreen = false;
        const photos = await this.getPhotos();
        this.render(photos);

        this.addEventListener('click', (e)=> {
            const closeFullScreen = e.target.hasAttribute('closeFullScreen') ? e.target : e.target.closest('[closeFullScreen]');
            const goToLayout = e.target.hasAttribute('layout') ? e.target : e.target.closest('[layout]');
            if (goToLayout) {
                this.selectPhoto(this.layoutIndex);
                e.stopPropagation();
            } else if(!this.fullScreen && !this.hasAttribute('no-fullscreen')) {
                this.renderFullScreen(photos);
                e.stopPropagation();
            }
            if(closeFullScreen && this.fullScreen){
                this.render(photos);
                e.stopPropagation();
            }

        })

        this.init();

    }

    render( initPhotos){
        this.closest('body').style.overflow = '';
        const buttonsContainer = document.querySelector('.cian-mobile-offer-card-buttons-container') || document.querySelector('.serp-jk-mobile-navigation');
        if(!!buttonsContainer){
            buttonsContainer.style.zIndex = '8';
            buttonsContainer.style.position = 'sticky';
        }
        const photos = initPhotos;
        this.layoutIndex = photos.findIndex(v => v.isLayout);
        this.fullScreen = false;
        const haveLayout = this.layoutIndex >= 0;
        const photoCount = photos.length;
        const width = photoCount * 100;
        const widthImg = 100 / photos.length;
        const formatted = photos.slice(1).map(p => `<img isLayout="${p.isLayout}" draggable="false" loading="lazy" style="; box-sizing: border-box; object-fit: ${p.isLayout ? "contain" : "cover" }; height: 100%; width: ${widthImg}%; margin: auto;" src="${p.mobileUrl}">`).join('\n')
        let imgs =
            `<img isLayout="${photos[0].isLayout}" draggable="false" style="; box-sizing: border-box; object-fit: ${photos[0].isLayout ? "contain" : "cover" }; height: 100%; width: ${widthImg}%; margin: auto;" src="${photos[0].mobileUrl}">${formatted}`;
        this.innerHTML = `
                    <div style="width: 100%; height: 100%; overflow: hidden; box-sizing: border-box; position: relative">
                        <div cian-count-photo__container class="cian-count-photo__container" style="display: flex; position: absolute; top: 14px; right: 14px; background: #0006; color: white; z-index: 1; border-radius: 14px; padding: 4px 12px">
                           <div photonum>1</div>/${photoCount}
                        </div>
                        ${haveLayout ? `
                        <div layout style="display: ${photos[0].isLayout ?  'none' : 'flex'};align-items: center; justify-content: center; position: absolute; bottom: 14px; left: 14px; background: #0005; color: white; z-index: 1; border-radius: 14px; padding: 4px 12px">
                           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="10.5" y="0.5" width="5" height="11" stroke="white"/>
                                <rect x="10.5" y="7.5" width="5" height="4" stroke="white"/>
                                <rect x="0.5" y="0.5" width="10" height="15" stroke="white"/>
                            </svg>
                            <div style="margin-left: 5px">Планировка</div>
                        </div>
                        ` : ""}
                        <div scroll style="width: ${width}%; height: 100%; display: flex; left: 0px; top: 0px; position: absolute">
                            ${imgs}
                        </div>
                    </div>
                `;
    }

    renderFullScreen(initPhotos){
        this.closest('body').style.overflow = 'hidden';
        const buttonsContainer = document.querySelector('.cian-mobile-offer-card-buttons-container') || document.querySelector('.serp-jk-mobile-navigation');
        if(!!buttonsContainer){
            buttonsContainer.style.zIndex = '9999';
            buttonsContainer.style.position = 'fixed';
            // buttonsContainer.style.margin = '0 16px';
        }
        const photos = initPhotos;
        const annotation = this.getAttribute('text')||'';
        this.layoutIndex = photos.findIndex(v => v.isLayout);
        this.fullScreen = true;
        const haveLayout = this.layoutIndex >= 0;
        const photoCount = photos.length;
        const width = photoCount * 100;
        const widthImg = 100 / photos.length;
        const formatted = photos.slice(1).map(p => `<div style="height: 100%; display: flex; align-items: center; width: ${widthImg}%; margin: auto;"><img isLayout="${p.isLayout}" draggable="false" loading="lazy" style=" box-sizing: border-box; object-fit: ${p.isLayout ? "contain" : "cover" }; max-width: 100%; max-height: 100%; position: relative; margin: auto;" src="${p.mobileUrl}"></div>`).join('\n')
        let imgs = `<div style="height: 100%; width: ${widthImg}%; margin: auto; display: flex; align-items: center; "><img isLayout="${photos[0].isLayout}" draggable="false" style="box-sizing: border-box; object-fit: ${photos[0].isLayout ? "contain" : "cover" }; max-width: 100%; max-height: 100%; margin: auto;" src="${photos[0].mobileUrl}"></div> ${formatted}`;
        this.innerHTML = `
                    <div style="position:fixed; z-index: 9999;left: 0;top: 0;height: 100%;width: 100%;background-color: rgb(0,0,0); overflow: hidden;">
                        <div style="width: 100%; height: 100%; overflow: hidden; box-sizing: border-box; position: relative">
                            <div class="cian-photo-gallery-mobile-full__info" style="height: 44px; width: 100%; display: flex; justify-content: space-between; align-items: center; position: absolute; top: 0; left:0">
                                <div style="color: white; padding: 0 16px">${annotation}</div>
                                <div closeFullScreen style="padding: 0 16px; display: flex; align-items: center">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.4142 12L17.7072 7.707C18.0982 7.316 18.0982 6.684 17.7072 6.293C17.3162 5.902 16.6842 5.902 16.2933 6.293L12.0002 10.586L7.70725 6.293C7.31625 5.902 6.68425 5.902 6.29325 6.293C5.90225 6.684 5.90225 7.316 6.29325 7.707L10.5862 12L6.29325 16.293C5.90225 16.684 5.90225 17.316 6.29325 17.707C6.48825 17.902 6.74425 18 7.00025 18C7.25625 18 7.51225 17.902 7.70725 17.707L12.0002 13.414L16.2933 17.707C16.4882 17.902 16.7443 18 17.0002 18C17.2562 18 17.5122 17.902 17.7072 17.707C18.0982 17.316 18.0982 16.684 17.7072 16.293L13.4142 12Z" fill="white"/>
                                    </svg>
                               
                                </div>
                            </div>
                            <div class="cian-photo-gallery-mobile-full__count" style="display: flex; position: absolute; bottom: 76px; left: calc(50% - 28px); background: rgba(38, 44, 64, 0.7); color: white; z-index: 1; border-radius: 14px; padding: 4px 12px">
                               <div photonum>1</div>/${photoCount}
                            </div>
                            ${haveLayout ? `
                            <div layout style="display: ${photos[0].isLayout ?  'none' : 'flex'};align-items: center; justify-content: center; position: absolute; bottom: 14px; left: 14px; background: #0005; color: white; z-index: 1; border-radius: 14px; padding: 4px 12px">
                               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="10.5" y="0.5" width="5" height="11" stroke="white"/>
                                    <rect x="10.5" y="7.5" width="5" height="4" stroke="white"/>
                                    <rect x="0.5" y="0.5" width="10" height="15" stroke="white"/>
                                </svg>
                                <div style="margin-left: 5px">Планировка</div>
                            </div>
                            ` : ""}
                            <div scroll style="width: ${width}%; height: calc(100% - 112px); left: 0px; top: 44px; position: absolute;display: flex; align-items: center">
                                ${imgs}
                            </div>
                            <div style="height: 50px; width: 100%; left: 0; bottom: 0; position: absolute; display: block"></div>
                        </div>
                    </div>
                `;
    }


    init() {
        let startX = false;
        let startLeft = false;
        let startY = false;
        const align = (initialLeft) => {
            const steps = 200 / 40;
            const photoCount = this.querySelectorAll('img').length;
            const element = this.querySelector('[scroll]');
            const startLeft = Number(/(-?[0-9]+)/.exec(element.style.left)[1])
            if (startLeft > 0) {
                const step = startLeft / steps;
                let iterator = 0;
                const move = () => {
                    const number = Math.floor(startLeft - (++iterator * step));
                    element.style.left = number + "px";
                    if (iterator < steps) {
                        setTimeout(move, 40);
                    } else {
                        element.style.left = 0;
                        this.animation = false;
                    }
                };
                this.animation = true;
                move();
                return
            }
            const lastLeft = (1 - 1 / photoCount) * -element.getClientRects()[0].width;
            if (startLeft < lastLeft) {
                const step = (lastLeft - startLeft) / steps;
                let iterator = 0;
                const move = () => {
                    const number = Math.ceil(startLeft + (++iterator * step));
                    element.style.left = number + "px";
                    if (iterator < steps) {
                        setTimeout(move, 40);
                    } else {
                        element.style.left = lastLeft + 'px';
                        this.animation = false;
                    }
                };
                this.animation = true;
                move();
                return
            }
            const imgWidth = Math.round(element.getClientRects()[0].width / photoCount);
            const imgIdx = initialLeft < startLeft ? Math.floor(Math.abs(startLeft / imgWidth)) : Math.ceil(Math.abs(startLeft / imgWidth));
            this.selectPhoto(imgIdx);
        };

        const mousedown = e => {
            const touch = !!e.touches;
            startY = e.touches && e.touches[0].clientY;
            e = touch && e.touches ? e.touches[0] : e;
            if (!this.animation) {
                startX = e.clientX;
                startLeft = Number(/(-?[0-9]+)/.exec(this.querySelector('[scroll]').style.left)[1]);
            }
        };
        const cancel = () => {
            if (!this.animation) {
                align(startLeft);
                startX = false;
            }
        };
        const mousemove = e => {
            const minValue = 5; // threshold
            let clientY = e.touches && e.touches[0].clientY - startY;

            const touch = !!e.touches;
            e = touch ? e.touches[0] : e;
            if (!this.animation && startX !== false && Math.abs(clientY) < minValue) {
                if (touch || e.buttons > 0) {
                    this.querySelector('[scroll]').style.left = (startLeft + e.clientX - startX) + "px";
                } else {
                    align(startLeft);
                    startX = false;
                }
            }

        };
        this.addEventListener("mousedown", mousedown);
        this.addEventListener("touchstart", mousedown);

        this.addEventListener("mouseup", cancel);
        this.addEventListener("mouseleave", cancel);
        this.addEventListener("touchend", cancel);
        this.addEventListener("touchcancel", cancel);

        this.addEventListener('mousemove', mousemove);
        this.addEventListener('touchmove', mousemove, {passive: false});

    };

    selectPhoto(imgIdx) {
        const steps = 200 / 40;
        const photoCount = this.querySelectorAll('img').length;
        const element = this.querySelector('[scroll]');
        const startLeft = Number(/(-?[0-9]+)/.exec(element.style.left)[1])
        const imgWidth = Math.round(element.getClientRects()[0].width / photoCount);
        const targetLeft = -imgWidth * imgIdx;
        const step = (targetLeft - startLeft) / steps;
        let iterator = 0;
        const move = () => {
            const number = Math.ceil(startLeft + (++iterator * step));
            element.style.left = number + "px";
            if (iterator < steps) {
                setTimeout(move, 40);
            } else {
                element.style.left = targetLeft + 'px';
                this.animation = false;
                if (this.querySelector('[layout]')) {
                    const selector = `[scroll] :nth-child(${imgIdx + 1})`;
                    let nthPhoto = this.querySelector(selector);
                    this.querySelector('[layout]').style.display = nthPhoto.getAttribute('isLayout') === "true" ? "none" : "flex";
                }
                if (this.querySelector('[photonum]')) {
                    this.querySelector('[photonum]').innerHTML = "" + (imgIdx + 1);
                }
            }
        };
        this.animation = true;
        move();
    }

    touchStart(e){
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }

    preventTouch(e){
        const minValue = 5; // threshold

        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;

        // Vertical scrolling does not work when you start swiping horizontally.
        if(Math.abs(this.clientX) > minValue){
            e.preventDefault();
            e.returnValue = false;
            return false;
        }
    }

    disconnectedCallback() {
        window.removeEventListener('touchstart', (e) => this.touchStart(e));
        window.removeEventListener('touchmove', (e) => this.preventTouch(e), {passive: false});
    }
});

